import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { dispatchGlobalErrorFromCatch } from 'utils/errors';

const useGlobalErrorHandler = () => {
  const dispatch = useDispatch();

  return useCallback(
    ({ error, defaultErrorMessageIntl, codeToMessageIntl = {} }) => {
      console.error(error);
      dispatchGlobalErrorFromCatch({
        dispatch,
        error,
        defaultErrorMessageIntl,
        codeToMessageIntl,
      });
    },
    [dispatch],
  );
};

export default useGlobalErrorHandler;
